import { useEffect } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Layout } from "@components/Layout/index";
import {
  getAboutPage,
  getAllDocumentsByType,
  getModalSettings,
  getGlobalConfig,
} from "@lib/api/calls";
import { trackEvent } from "@lib/track-event";
import { Render } from "@components/sections";
import styles from "./About.module.css";

export default function Index({ preview, title, seo, content, slug, config, subscribed, modal }) {
  useEffect(() => {
    trackEvent("view_page", {
      pageTitle: title,
      pageCategory: "Information Page",
      pageLocation: window.location.href,
      pagePath: window.location.pathname,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //   console.log("content", content);

  return (
    <Layout
      config={config}
      title={title}
      seo={seo}
      subscribed={subscribed}
      isPreview={preview}
      pageFound={slug !== null}
      modal={modal}
    >
      <main className={styles.container}>{content && <Render sections={content} />}</main>
    </Layout>
  );
}

export async function getStaticPaths() {
  // Return a list of possible value for id
  const allPages = await getAllDocumentsByType("about");
  const paths =
    allPages?.map((page) => ({
      params: {
        slug: page.slug || "",
      },
    })) || [];
  return {
    paths,
    fallback: true,
  };
}

export async function getStaticProps({ params, preview = false, locale }) {
  const page = params?.slug ? await getAboutPage(params.slug, locale, preview) : null;
  const modal = await getModalSettings(locale, preview);
  const config = await getGlobalConfig(locale, preview);

  const seo = {
    seoTitle: page?.meta?.seoTitle || null,
    seoDescription: page?.meta?.seoDescription || "",
    openGraphImage: page?.meta?.openGraphImage || null,
    twitterCard: page?.meta?.seoTwitterCardStyle || "summary_large_image",
  };

  return {
    props: {
      preview,
      title: page?.title || null,
      seo,
      content: page?.blocks || null,
      slug: page?.slug || null,
      modal,
      config,
      ...(await serverSideTranslations(locale, [
        "common",
        "navbar",
        "footer",
        "cart",
        "recommendations",
      ])),
    },
    revalidate: 1800,
  };
}
